import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import React from 'react';

export interface BackBubbleButtonProps {
  onClick?: () => void;
  'aria-label'?: string;
}

const BackBubbleButton: React.FC<BackBubbleButtonProps> = ({
  onClick,
  'aria-label': ariaLabel = 'Volver atrás',
}) => (
  <IconButton
    onClick={onClick}
    aria-label={ariaLabel}
    sx={{
      position: 'relative',
      zIndex: 10,
      width: 44,
      height: 44,
      borderRadius: '50%',
      backgroundColor: 'background.paper',
      color: 'text.primary',
      boxShadow: 2,
      '&:hover': {
        backgroundColor: 'action.hover',
      },
      '&:focus-visible': {
        outline: '2px solid',
        outlineColor: 'primary.main',
      },
    }}
  >
    <ArrowBackIcon sx={{ fontSize: 24 }} />
  </IconButton>
);

export default BackBubbleButton;
